import { StartGameTranslations } from "./types";

export const deTranslations: StartGameTranslations = {
    loginExpired: "Bitte melden Sie sich erneut an. Die Anmeldung ist abgelaufen.",
    errorOccurred: "Ein Fehler ist aufgetreten: ",
    failedToStartGame: "Sitzung konnte nicht gestartet werden",
    enterName: "Bitte vergeben Sie einen Titel für diese Session",
    gameAnonymised:
        "Dieser Session-Titel dient Ihnen zum späteren Wiederauffinden Ihrer Ergebnisse. Sie können den Titel völlig frei wählen. Bitte tragen Sie hier keine personenbezogenen Daten ein (es sei denn, Sie nehmen an einem Studienprojekt teil, in dessen Rahmen Sie gebeten wurden, einen besonderen Code einzugeben).",
    placeholder: "Kardiologie 101",
    startGame: "Start",
    loaderText: "Bitte warten Sie einen Moment."
};
